import React from 'react';
import { Profile } from '~/types/models';
import SearchResultRow from './SearchResultRow';

export interface SearchResultsProps {
  contacts: Profile[];
  selectedContact?: Profile;
  onContactSelected: (contact: Profile) => void;
}

export default function SearchResults({
  contacts,
  onContactSelected,
  selectedContact,
}: SearchResultsProps) {
  return (
    <>
      {contacts.map((contact) => {
        return (
          <SearchResultRow
            selected={selectedContact?.id === contact.id}
            onContactSelected={onContactSelected}
            key={contact.id}
            contact={contact}
          />
        );
      })}
    </>
  );
}
